import { useQuery } from '@tanstack/react-query'
import { getTenant } from '../services/auth-api'

export function useOrganization() {
  return useQuery({
    queryKey: ['auth-tenant'],
    queryFn: getTenant,
  })
}
